import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 메뉴 스크롤 타입 제어 컴포넌트
 * 원본: menu-scroll-control.html
 */
const MenuScrollControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;
  const isFixedWithMore = themeConfig.menuScrollType === 'fixedWithMore';
  const fixedMenuCount = Math.max(1, Math.min(20, Number(themeConfig.fixedMenuCount) || 6));

  return (
    <div id="menu-scroll-type-wrapper" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#333', margin: 0, flex: 1 }}>📜 상단 메뉴 표시 유형:</label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="menu-scroll-type-wrapper"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = 'var(--theme-color-primary)';
            e.target.style.color = 'var(--theme-color-primary)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = '#ddd';
            e.target.style.color = '#666';
          }}
        >
          ?
        </button>
      </div>
      <CustomSelect
        value={themeConfig.menuScrollType}
        onChange={(v) => set('menuScrollType', v)}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'wrap', label: '개행 유형 (기본) - 메뉴 항목이 길면 아래로 개행' },
          { value: 'scroll', label: '가로 스크롤 유형 - 1줄로 표시하고 가로 스크롤' },
          { value: 'fixedWithMore', label: '고정 메뉴 항목 이외에는 더보기' },
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 36,
            fontSize: 13,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }}
      />
      {isFixedWithMore && (
        <div style={{ marginTop: '12px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>
            고정 메뉴 항목 수:
          </label>
          <input
            type="number"
            min={1}
            max={20}
            value={fixedMenuCount}
            onChange={(e) => {
              const v = parseInt(e.target.value, 10);
              if (!Number.isNaN(v)) set('fixedMenuCount', Math.max(1, Math.min(20, v)));
            }}
            style={{
              width: '80px',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #ddd',
              borderRadius: '4px',
            }}
          />
        </div>
      )}
      <div style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>상단 배치일 때만 적용됩니다.</div>
    </div>
  );
};

export default MenuScrollControl;

